import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageHeader from "@core/components/pageHeader";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import Utility from "@core/helper/utility";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import BannerList from "views/pages/banner/BannerList";
import AddBanner from "views/pages/banner/AddBanner";
import Loader from "@core/helper/Loader";

const Banner = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [bannerList, setBannerList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState("");
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");

  const location = useLocation();

  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteBanner)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = bannerList.filter((o) => o.id !== id);
            setBannerList(filter);
            fetchBannerList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setSearchText("");
    setType(type);
    if (id) {
      const findList = bannerList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const annodata = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });

      setPermission(annodata[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  useEffect(() => {
    fetchBannerList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageSize, pageNumber]);

  const fetchBannerList = () => {
    Loader.isLoading(true);

    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "ASC",
      searchText,
    };
    APICall("post", payload, EndPoints.getBanner)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setBannerList(results);
          setTotalRecord(totalCount);
        } else {
          setBannerList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitBanner = () => {
    fetchBannerList();
  };
  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Banner
          </Typography>
        }
      />

      <Grid item xs={12}>
        <BannerList
          handleDeleteModal={handleDeleteModal}
          deleteOpen={deleteOpen}
          handleOpen={handleOpen}
          bannerList={bannerList}
          pageSize={pageSize}
          setPageSize={setPageSize}
          searchText={searchText}
          setSearchText={setSearchText}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          totalRecord={totalRecord}
          permission={permission}
          role={role}
        />
      </Grid>

      {openModal && (
        <AddBanner
          open={openModal}
          toggle={handleOpen}
          type={type}
          heading={type === "edit" ? "Update Banner" : "Add Banner"}
          onSubmitBanner={submitBanner}
          updateData={updateData}
          role={role}
        />
      )}
    </Grid>
  );
};

export default Banner;
